const routes = [
  {
    path: 'formsubmit',
    component: () => import(/* webpackChunkName: "formsubmit" */ '@/modules/formsubmit/index.vue'),
    children: [
      {
        path: '',
        name: 'formsubmit',
        component: () => import(/* webpackChunkName: "demo1" */ '@/modules/formsubmit/demo1.vue'),
      },
      {
        path: 'demo1',
        component: () => import(/* webpackChunkName: "demo1" */ '@/modules/formsubmit/demo1.vue'),
      },
      {
        path: 'demo2',
        component: () => import(/* webpackChunkName: "demo2" */ '@/modules/formsubmit/demo2.vue'),
      },
    ],
  },
];

export default routes;